// Kleinteile, die alle Schritte brauchen.

import type { StepCheck } from "../../api/types";
import { checkText } from "../../lib/labels";
import { Note } from "../../ui/badge";

/** Der Satz zum Prüfcode eines Felds — leer, wenn das Feld in Ordnung ist. */
export function fieldError(check: StepCheck | null, key: string): string {
  const code = check?.errors[key];
  return code ? checkText(code) : "";
}

/** Geheimnisse werden nie angezeigt: ein leeres Feld heißt „behalten". */
export const secretPlaceholder = (set: boolean | undefined): string => (set ? "gesetzt — leer lassen zum Behalten" : "");

/** Die Warnungen eines Prüfergebnisses, je eine gelbe Notiz. */
export function Warnings({ check }: { check: StepCheck | null }) {
  return <>{(check?.warnings ?? []).map((w) => <Note key={w} tone="warn">{checkText(w)}</Note>)}</>;
}

/** Ein Feld des Zustands setzen: `const set = setter(setState); set("name")(wert)`. */
export function setter<S>(setState: (fn: (s: S) => S) => void) {
  return <K extends keyof S>(key: K) => (value: S[K]) => setState((s) => ({ ...s, [key]: value }));
}
